<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card height="80vh" class="edit-mission-main-card">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-5">
              <v-row no-gutters>
                <v-col cols="1"></v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" class="mt-3">
                  <v-row>
                    <span :class="editInfoTabClass" @click="changeTab('mission')">
                      اطلاعات ماموریت
                    </span>
                    <v-spacer></v-spacer>
                    <span :class="timeTabClass" @click="changeTab('time')">زمان ها و وضعیت</span>
                    <v-spacer></v-spacer>
                    <span :class="doctorInsideTabClass" @click="changeTab('doctor')">
                      دستورات پزشکی
                    </span>
                    <v-spacer></v-spacer>
                    <span :class="moreTabClass" @click="changeTab('moreInfo')">سایر اطلاعات</span>
                    <v-spacer></v-spacer>
                    <span :class="noteTabClass" @click="changeTab('note')">توضیحات</span>
                    <v-spacer></v-spacer>
                    <span :class="addressTabClass" @click="changeTab('address')">سابقه آدرس</span>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="text-left mt-n2 ml-2">
                  <v-icon color="darkColor" @click="closeMissionDetailModal()">mdi-close</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text class="mt-3">
            <v-row no-gutters>
              <v-col cols="12" v-if="missionReportDetailTab == 'mission'">
                <v-row>
                  <span class="mr-3">اطلاعات ماموریت</span>
                  <v-divider class="mr-2 mt-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col v-for="(item, index) in missionInfo" :key="index" :cols="item.col" class="mt-n2">
                    <v-card class="card-info-send-mission" elevation="0" height="5vh">
                      <v-card-text>
                        <v-row>
                          <v-icon color="darkColor">{{ item.icon }}</v-icon>
                          <span class="mt-1 send-mission-info-title-content mr-2">
                            {{ item.title }}:
                          </span>
                          <span class="mr-4 mt-1 send-mission-info-text-content">
                            {{ item.content }}
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <span class="mr-3">کاربران</span>
                  <v-divider class="mr-2 mt-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col v-for="(item, index) in users" :key="index" :cols="item.col">
                    <v-card class="card-info-send-mission" elevation="0" height="5vh">
                      <v-card-text>
                        <v-row>
                          <span class="mt-1 send-mission-info-title-content">
                            {{ item.title }}:
                          </span>
                          <span class="mr-2 mt-1 send-mission-info-text-content">
                            {{ item.content }}
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="missionReportDetailTab == 'time'">
                <v-row>
                  <v-col cols="12" class="mb-9">
                    <v-row>
                      <span>زمان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-n3">
                    <v-row>
                      <v-col v-for="item in missionTimes" :key="item.id" :cols="item.size">
                        <user-detail-component has-icon v-if="item.title" :title="item.title" :size="item.size"
                          :text="item.text" :icon="item.icon" :per="item.per" :perKey="item.perKey"
                          :secondText="item.secondText"></user-detail-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-row>
                      <span class="mr-3">وضعیت ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="">
                    <edit-dialog-information-component v-if="missionReportDetailTab == 'time'"
                      :tableHeader="stateDataTableHeader" :tableItems="stateDataTableItems"
                      :height="'30vh'"></edit-dialog-information-component>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="missionReportDetailTab == 'note'">
                <v-row>
                  <span>توضیحات</span>
                  <v-divider class="mt-2 mr-3"></v-divider>
                </v-row>
                <v-row>
                  <v-col cols="12" class="note-component-space mt-n4">
                    <v-row>
                      <v-col cols="12" v-for="item in noteList" :key="item.id" class="mb-5">
                        <dispatch-note-component :user="item.user" :date="item.date"
                          :note="item.note"></dispatch-note-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card elevation="0" height="17vh" class="note-box">
                      <v-row>
                        <v-col cols="2" class="not-box-title">
                          <span>افزودن توضیحات</span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" class="note-box-input">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="11">
                              <v-textarea outlined prepend-inner-icon="mdi-text mdi-18px" rows="2"
                                @keydown="noteHandler" clearable clear-icon="mdi-close-circle-outline"
                                placeholder="توضیحات" v-model="noteText"></v-textarea>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="mt-n10">
                              <v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="lightColor" @click="addNote()" class="ml-4 normal-letter-spacing" text>
                                  <v-icon color="lightColor">mdi-check mdi-18px</v-icon>
                                  ثبت توضیحات
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="missionReportDetailTab == 'address'">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <span>نقشه</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <div id="map">
                              <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 60vh !important" :zoom="zoom"
                                :center="center" :options="mapOptions" @update:center="centerUpdate"
                                @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                                <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                                <!-- <l-polyline
                                  :lat-lngs="polyline.latlngs"
                                  :color="polyline.color"
                                ></l-polyline> -->
                                <l-control position="bottomleft">
                                  <v-btn small rounded dark color="darkColor" class="no-letter-space"
                                    @click="showLine()">
                                    مشاهده مسیر
                                  </v-btn>
                                </l-control>
                                <!-- path-markers -->

                                <l-marker v-if="currentZoom > 14" v-for="(item, index) in pathsList" :key="index"
                                  :lat-lng="[item.latitude, item.longitude]" :icon="getPathsIcon(item)">
                                  <v-popup>
                                    <section>
                                      <div class="flex-gap-1">
                                        <div>تاریخ و زمان :</div>
                                        <div>
                                          {{ getCurrentLocationTime(item?.date) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>سرعت :‌</div>
                                        <div>KM/h</div>
                                        <div>
                                          {{ item?.speed.toFixed(2) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>وضعیت :</div>
                                        <div>
                                          {{ item?.state ?? 'ندارد' }}
                                        </div>
                                      </div>
                                    </section>
                                  </v-popup>
                                </l-marker>
                                <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
                                <!-- Marker -->
                                <!-- <l-marker
                                  v-for="(item, index) in mapMarkers"
                                  :key="index"
                                  visible
                                  :icon="icon"
                                  :lat-lng.sync="item.position"
                                >
                                  <v-popup class="pa-0 ma-0">
                                    <v-row no-gutters>
                                      <v-col class="text-center">
                                        <span>{{
                                          item.state
                                        }}</span>
                                      </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-list dense class="mt-3">
                                      <v-list-item dense class="mt-n6">
                                        <v-list-item-title class="text-right">{{
                                          item.date
                                        }}</v-list-item-title>
                                      </v-list-item>
                                      <v-list-item dense class="mt-n4">
                                        <v-list-item-title class="text-right">{{
                                          item.time
                                        }}</v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-popup>
                                </l-marker> -->
                              </l-map>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <span>سابقه آدرس</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="missionReportDetailTab == 'address'"
                              :tableHeader="addressDataTableHeader" :tableItems="addressDataTableItems"
                              height="25vh"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                        <v-row>
                          <span>سابقه موقعیت جغرافیایی</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component v-if="missionReportDetailTab == 'address'"
                              :tableHeader="locationConfiramtionTableHeader" :tableItems="missionConfirmations"
                              height="25vh" @rowClick="showConfirmationLocation"
                              class="location-table"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="missionReportDetailTab == 'doctor'">
                <v-row>
                  <v-col class="doctor-part" cols="12" v-for="item in allDoctorOrders" :key="item.id">
                    <v-row class="mt-1">
                      <span class="mr-4">{{ item.patient }}</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorInfoDataTableHeader"
                          :tableItems="item.doctorInfoDataTableItems"
                          :height="'10vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorDrugDataTableHeader"
                          :tableItems="item.doctorDrugDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorOrderDataTableHeader"
                          :tableItems="item.doctorOrderDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="missionReportDetailTab == 'moreInfo'">
                <v-row>
                  <v-col class="doctor-part mt-n5" cols="12">
                    <v-row class="mt-2">
                      <span class="mr-4">جزئیات 115</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col v-for="(item, index) in info115" :key="index" :cols="item.col" class="mt-n2">
                        <v-card class="card-info-send-mission" elevation="0" height="5vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="darkColor">{{ item.icon }}</v-icon>
                              <span class="mt-1 send-mission-info-title-content mr-2">
                                {{ item.title }}:
                              </span>
                              <span class="mr-4 mt-1 send-mission-info-text-content">
                                {{ item.content }}
                              </span>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <span class="mr-4">اطلاعات پذیرش</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="admissionDataTableHeader"
                          :tableItems="admissionDataTableItems" :height="'25vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                    <v-row class="mt-4">
                      <span class="mr-4">درخواست های سایر ارگان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="otherOrganDataTableHeader"
                          :tableItems="otherOrganDataTableItems" :height="'25vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import AlertComponent from '@/components/AlertComponent.vue';
import UserDetailComponent from '@/components/UserDetailComponentNew.vue';
import EditDialogInformationComponent from '@/components/115/EditDialogInformationComponent.vue';
import DispatchNoteComponent from '@/components/800/DispatchNoteComponent.vue';
import mapSharedHelper from '@/Helpers/mapShared.helper';
import snackBar from '@/Mixins/snackBar.js';
import SharedMixin from '@/Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';

import TagMixin from '@/Mixins/BaseInformation/TagMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import missionStateMixin from '@/Mixins/Mission/MissionStateMixin';
import missionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MissionAddressLogMixin from '@/Mixins/Mission/MissionAddressLogMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin';
import SharedMap from '@/Mixins/map';
import MissionReportDetailHelper from '@/Helpers/Report/Shared/MissionReportDetailHelper.js';

import MissionTranform from '@/Helpers/800/mission.transform';

export default {
  name: 'MissionReportDetail',
  title: 'جزئیات ماموریت',
  inject: ['load'],
  components: {
    UserDetailComponent,
    EditDialogInformationComponent,
    AlertComponent,
    DispatchNoteComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    'v-popup': LPopup,
  },
  mixins: [
    MissionReportDetailHelper,
    snackBar,
    SharedMixin,
    TagMixin,
    CityMixin,
    MissionPhonesMixin,
    missionStateMixin,
    missionNoteMixin,
    HospitalMixin,
    ZoneMixin,
    DispatchCodeMixin,
    StationMixin,
    MissionAddressLogMixin,
    MissionMixin,
    PhoneOnlineLocationMixin,
    PatientDoctorDetailMixin,
    SharedHelper,
    mapSharedHelper,
    SharedMap,
    MissionTranform
  ],
  created() {
    this.$root.$refs.MissionReportDetail = this;
  },
  mounted() {
    this.mounteLoding();
  },
  props: {
    missionId: {
      type: Number,
      require: true,
      default: null,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    phoneId: {
      type: Number,
      require: true,
    },
    patientId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      patiantPosition: {},
      dragging: false,
      icon: this.getIcon,
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.getMissionPhoneReportDetailFunction(this.missionPhoneId);
      this.getMissionPhoneReportUsersFunction(this.missionPhoneId, this.patientId);
      this.setMapBaseSystemSetting();
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    getMovingIcon(data) {
      if (data.isPhoneLocation == true) {
        //is phone
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      } else if (data.isPhoneLocation == false) {
        //is gps
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      }
    },
    // show previous path
    showAntPath(latLngs) {
      const antPath = L.polyline.antPath(latLngs);
      antPath.addTo(this.$refs.modalmap.mapObject);
    },
    getPathsIcon(data) {
      if (data?.speed > 3) {
        const iconImg = this.movingIconForGPSWithMission;
        return L.divIcon({
          className: 'my-custom-pin',
          html: `<img src="${iconImg}" style="width:15px; height:15px; transform:rotate(${data.bearing}deg)"/>`,
        });
      }
      const iconImg = this.stoppedVehicleIcon;
      return L.divIcon({
        className: 'my-custom-pin',
        html: `<img src="${iconImg}" style="width:30px; height:30px;transform:translateY(-160%)"/>`,
        iconAnchor: [-15, -45],
      });
    },
  },
};
</script>
<style scoped>
.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 600;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}

.edit-modal-card-detail {
  border-radius: 12px !important;
  border: 1px solid var(--dark-color) !important;
}

.modal-title-text-menu {
  cursor: pointer;
}

.phone-numbers-items {
  background: var(--background-color) !important;
  border-radius: 5px !important;
  padding-right: 15px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.phone-numbers-items-icon {
  background: var(--dark-color) !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-radius: 5px !important;
}

.edit-mission-main-card {
  overflow-y: auto;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 45vh !important;
  overflow-y: auto !important;
}

.phone-code {
  color: var(--dark-color);
  margin-right: 5px !important;
}

.menu-top-items {
  cursor: pointer !important;
}

.active-tab {
  color: var(--dark-color) !important;
  background: var(--background-color) !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}
</style>
